import { shape, string } from "prop-types"

export const CostCodeShape = shape({
    costCodeGroupId: string.isRequired,
    code: string.isRequired,
    description: string
})